import { useState, useEffect, useRef } from "react";
import { Modal, Button, Spin, Alert, message, Typography, Empty } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

import axiosInstance from "../../../shared/axios";
import PayReceipt from "./PayReceipt";
import { ReadyToPrint } from "../ReadyToPrint";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const PayReceiptModal = ({ visible, appointmentId, onClose, receiptData }) => {
  const componentRef = useRef(null);
  console.log("receiptData:", receiptData);
  // ✅ Pass a function that returns the DOM node directly
  const reactToPrintFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Receipt_${appointmentId}`,
    pageStyle: `
    @page {
      size: A4 portrait;
      margin: 10mm;
    }
  `,
    // onAfterPrint: () => message.success("Printing receipt..."),
  });
  const [loading, setLoading] = useState(false);
  const [receiptDatas, setReceiptDatas] = useState(null);
  const [error, setError] = useState(null);

  // const fetchAppointmentData = async () => {
  //   if (!appointmentId || isNaN(appointmentId) || appointmentId <= 0) {
  //     setError("Invalid appointment ID.");
  //     return;
  //   }

  //   setLoading(true);
  //   setError(null);

  //   try {
  //     const response = await axiosInstance.get(
  //       `/appointment/edit/${appointmentId}`,
  //     );

  //     if (response.data.success && response.data.data) {
  //       setReceiptDatas(response.data.data);
  //       console.log("edit appointment data", response?.data?.data);
  //     } else {
  //       setError("Appointment not found.");
  //     }
  //   } catch (err) {
  //     setError("Failed to load receipt. Please try again.");
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   if (visible) {
  //     if (appointmentId && !isNaN(appointmentId) && appointmentId > 0) {
  //       fetchAppointmentData();
  //     } else {
  //       setReceiptDatas(null);
  //     }
  //   }
  // }, [visible, appointmentId]);

  const handlePrint = () => {
    if (!componentRef.current) {
      message.error("Receipt not ready");
      return;
    }
    reactToPrintFn();
  };

  const handleClose = () => {
    setReceiptDatas(null);
    setError(null);
    onClose();
  };

  return (
    <Modal
      title="Print Pay Receipt"
      centered
      width={800}
      open={visible}
      onCancel={handleClose}
      footer={
        <Button
          style={{ background: "#2F80ED" }}
          className="text-white border-0"
          icon={<PrinterOutlined />}
          onClick={handlePrint}
          disabled={!receiptData}
        >
          Print Receipt
        </Button>
      }
    >
      <div>
        {/* Loading */}
        {/* {loading && (
          <div style={{ textAlign: "center", padding: 60 }}>
            <Spin size="large" tip="Loading receipt..." />
          </div>
        )} */}

        {/* Error */}
        {/* {error && (
          <Alert message="Error" description={error} type="error" showIcon />
        )} */}

        {/* No ID */}
        {/* {!appointmentId && !loading && !error && (
          <Empty description="No appointment selected for printing." />
        )} */}

        {/* Success: Show ONE receipt */}
        {/* {receiptData && !loading && !error && (
          <div ref={componentRef}>
            <PayReceipt data={receiptData} />
          </div>
        )} */}

        <div ref={componentRef} className="print-container">
          <PayReceipt data={receiptData} />
        </div>
      </div>
    </Modal>
  );
};

export default PayReceiptModal;
